export const MEMBER_STATUS_OPTIONS = [
  {
    value: "active",
    label: "Aktiv",
    description: "Mitglied ist aktiv und zahlt regulär Beitrag.",
    effect:
      "Das Mitglied bleibt regulär im Betrieb und wird als aktiv geführt.",
    color: "success",
    icon: "mdi:check-circle-outline",
  },
  {
    value: "frozen",
    label: "Eingefroren",
    description: "Mitglied pausiert z. B. wegen Reise oder Verletzung.",
    effect:
      "Das Mitglied bleibt erhalten, der Status zeigt eine vorübergehende Pause.",
    color: "info",
    icon: "mdi:snowflake",
  },
  {
    value: "terminated",
    label: "Gekündigt",
    description: "Mitglied wurde gekündigt.",
    effect:
      "Das Mitglied wird als beendet geführt und ist nicht mehr regulär aktiv.",
    color: "error",
    icon: "mdi:close-circle-outline",
  },
  {
    value: "pending",
    label: "Wartend",
    description:
      "Mitglied wurde über die öffentliche Registrierung angemeldet und wartet auf Bestätigung.",
    effect:
      "Die Anmeldung bleibt offen, bis ein Admin die Registrierung bestätigt oder ablehnt.",
    color: "warning",
    icon: "mdi:timer-sand",
  },
  {
    value: "rejected",
    label: "Abgelehnt",
    description: "Mitglied wurde nach öffentlicher Registrierung abgelehnt.",
    effect:
      "Die öffentliche Anmeldung ist abgeschlossen und als abgelehnt markiert.",
    color: "default",
    icon: "mdi:cancel",
  },
];

export const ALLOWED_MEMBER_STATUSES = MEMBER_STATUS_OPTIONS.map(
  (status) => status.value,
);

export const normalizeMemberStatus = (status) =>
  String(status || "")
    .trim()
    .toLowerCase();

export const getMemberStatusConfig = (status) => {
  const normalized = normalizeMemberStatus(status);
  return (
    MEMBER_STATUS_OPTIONS.find((item) => item.value === normalized) || {
      value: normalized || "unknown",
      label: "Unbekannt",
      description: "Status ist nicht eindeutig zugeordnet.",
      effect: "Bitte wählen Sie einen gültigen Status aus.",
      color: "default",
      icon: "mdi:help-circle-outline",
    }
  );
};
